import React from 'react';
import useQueryObject from '../../shared/utils/useQueryObject';
import {Icon, Page, Tile} from '../../shared';
import {_openModal} from '../../shared/reducers/modals';
import ExposureGraph from '../../shared/widgets/ExposureGraph';
import {getBackPath} from '../shared/utils/dashboardUtils';
import history from '../../history';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import debug from 'debug';

const log = debug('circleblack:investor:page:ExposurePage');

const ExposurePage = ({openModal}) => {
  log('rendering');
  const [context] = useQueryObject('context');

  const backPath = getBackPath();

  return <Page>
    <Tile key={'Exposure'}
          title={'Exposure'}
          minHeight={'250px'}
          height={'calc(100vh - 200px)'}
          icon={<Icon svg={'arrowCircle'}
                      rotate={'180deg'}
                      action={() => history.push(backPath)}/>}>
      <ExposureGraph cat={'containers'}
                     catID={context.containerID}
                     useInvestorPreference={true}
                     sliceAction={(slice, category, types) => context && openModal({
                       type: 'ExposureSecuritiesModal',
                       containerID: context.containerID,
                       category: category.value,
                       types: types.map(t => ({label: t.name, value: t.id})),
                       initialType: {
                         label: category.value === 'REGION' ? (slice.regionName || slice.name) : slice.name,
                         value: slice.ident,
                       },
                     }) }/>
    </Tile>
  </Page>;
};

const mapDispatchToProps = dispatch => ({
  openModal: content => dispatch(_openModal(content)),
});

export default connect(null, mapDispatchToProps)(ExposurePage);

ExposurePage.propTypes = {
  openModal: PropTypes.func.isRequired,
};
